import { ColumnDescription } from "react-bootstrap-table-next";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { useState } from "react";
import ModalComponent from "../../../Components/Modais";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ListarPesquisaSatisfacaoController } from "../../../Controllers/HelpDesk/GestaoRespostas/GestaoRespostasControllers";
import { IListagemDasPesquisasSatisfacaoRelatorios } from "../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import Table from "../../../Components/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ModalVisualizarPesquisaSatisfacao from "./ModalVisualizarPesquisaSatisfacao";
import { formatedTelefone } from "../../../Tools/FormatTools";

export default function PesquisaSatisfacao() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: lstPesquisaSatisfacao,
        loading: lstPesquisaSatisfacaoLoading,
    } = useAsyncEffect(() =>
        ListarPesquisaSatisfacaoController({
            PAGINA: 1,
            QUANTIDADE: 10,
        })
    );

    const tableviewColumns: Array<
        ColumnDescription<IListagemDasPesquisasSatisfacaoRelatorios>
    > = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (c, row) => {
                return (
                    <>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    Ver Pesquisa
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-info font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: `Visualizar Pesquisa Satisfação`,
                                        IconHeader: faEye,
                                        Component: () => (
                                            <ModalVisualizarPesquisaSatisfacao
                                                idContaChat={row.ID_CONTA_CHAT}
                                                visualizandoFormRespondido={
                                                    true
                                                }
                                                setShow={setShow}
                                                idFormulario={row.ID_FORMULARIO}
                                                lstPesquisaSatisfacao={row}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} size="lg" />
                            </button>
                        </OverlayTrigger>
                    </>
                );
            },
        },
        {
            dataField: "DS_FORMULARIO",
            text: `Formulário`,
        },
        {
            dataField: "DS_NOME",
            text: `Nome`,
        },
        {
            dataField: "NR_TELEFONE",
            text: `Telefone`,
            formatter: (c) => (c ? formatedTelefone(c) : "-"),
        },
        {
            dataField: "DT_FIM_CHAT",
            text: `Dt. Inicial do chat`,
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : "-"),
        },
        {
            dataField: "DT_FIM_CHAT",
            text: `Dt. Final do chat`,
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : "-"),
        },
    ];

    return (
        <>
            <div className="card">
                <Table
                    data={lstPesquisaSatisfacao?.Relatorios ?? []}
                    loading={lstPesquisaSatisfacaoLoading}
                    columns={tableviewColumns}
                    keyField="ID"
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhuma Pesquisa de Satisfação encontrada
                        </div>
                    )}
                    tableView={{
                        columns: tableviewColumns,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    bordered={false}
                    defaultStyle={{ align: "center" }}
                    striped={false}
                    rowClasses={"rowClasses"}
                    rowStyle={{ height: 60 }}
                    noSearch
                />
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
